import {
  GetBuildingDataWithGuidReq,
  GetUserInfoRes,
  getCountryCodes,
} from "api/network";
import { useEffect } from "react";
import { useBoundStore } from "store";
import { SP_NAMES } from "api/constants";
import { STORAGE_KEYS, storage } from "utils";
import { useQueryState } from "./use-query-state";
import { useItemLoader } from "./use-item-loader";

const token = storage.read<string>(STORAGE_KEYS.TOKEN);

export const useStartUp = () => {
  const { setUserInfo } = useBoundStore();

  const { query, setQuery } = useQueryState<{ _guid: string }>();
  const { setCountryCodes } = useBoundStore();

  const loadCountryCodes = async () => {
    try {
      const codes = await getCountryCodes();
      setCountryCodes(codes);
    } catch (error) {}
  };

  const userData = useItemLoader<GetUserInfoRes>(SP_NAMES.GetUserInfo);

  const buildingData = useItemLoader(SP_NAMES.GetBuildingDataWithGuid, {
    body: { CustomerClubGuid: query._guid } as GetBuildingDataWithGuidReq,
  });

  useEffect(() => {
    loadCountryCodes();
    token && userData.fetch();
  }, []);

  useEffect(() => {
    if (query._guid) {
      // buildingData.fetch();
    }
  }, []);

  useEffect(() => {
    userData.result && setUserInfo(userData.result);
  }, [userData.result]);

  return {
    loading: buildingData.isLoading,
  };
};
